interface FormRowProps {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  span?: boolean;
}

export function FormRow({ label, required, children, span }: FormRowProps) {
  return (
    <div className={`flex border-b border-gray-100 last:border-b-0 ${span ? 'items-start' : 'items-center'}`}>
      <div className="w-1/3 shrink-0 bg-gray-50 px-4 py-2.5 text-sm font-medium text-gray-600 border-r border-gray-200 self-stretch flex items-center">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </div>
      <div className="flex-1 px-4 py-2">
        {children}
      </div>
    </div>
  );
}
